(function () {
  Drupal.behaviors.futuristHeroV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }

      this.attached = true;
      var $thismodule = $('.js-futurist-hero', context);

      // Append quickshops to the correct product copy section.
      function appendQuickshopMobile() {
        var $parents = $thismodule.closest('.js-futurist-hero-container');

        $.each($parents, function (parent_index, parent_value) {
          var $parent = $(parent_value);
          var $localQS = $parent.find('.js-quick_shop');
          var $mpp = $parent.next('.mpp');
          var $productBrief = $mpp.find('.product-brief');
          var $content = $parent.find('.js-futurist-hero__content');
          var $mppQSContainer = $mpp.find('.js-quickshop-container');

          if ($content.length > 0 && $mpp.length > 0) {
            $mpp.find('.mpp__header').hide();
            $mpp.find('.mpp__product-sort-container').hide();
            $mpp.insertAfter($content);
          }
          if ($localQS.length > 0 && $productBrief.length > 0) {
            $productBrief.insertAfter($localQS);
            $productBrief.find('a:not(.js-quickshop-show, .js-quickshop-hide)').hide();
            $productBrief.find('.product-brief__price').hide();
            $productBrief.find('.product-brief__reviews').hide();
            $productBrief.addClass('futurist-quickshop');
            $localQS.hide();
          }
          $mppQSContainer.addClass('futurist-quickshop');
          $mpp.addClass('showing');
        });
      }

      if (isMobile()) {
        // Module fade in transition animation.
        $thismodule.addClass('futurist-hero-visible');
        // Wait for fade in animation to finish.
        setTimeout(function () {
          appendQuickshopMobile();
        }, 2000);
      }

      function isMobile() {
        return Unison.fetch.now().name === 'small';
      }
    }
  };
})(jQuery);
